import {
  TableContainer,
  Table,
  Tbody,
  Thead,
  Tr,
  Td,
  Th,
} from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { date as commonDate } from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

import {
  EventWithActorGQLType,
  FundingRequestWithFullDetailsGQLType,
} from 'types/dashboard-core-gqlTypes.generated';

import { FundingRequestStatusBadge } from '../shared/StatusBadge';
import { colors } from 'packages/common-frontend/colors';
import { dollarNumberWithCommas } from 'packages/common-frontend/utils';

// Exports
type Props = {
  fundingRequests: (Pick<
    FundingRequestWithFullDetailsGQLType,
    | 'id'
    | 'creditFacilityName'
    | 'created_at'
    | 'drawRequestTotalAmount'
    | 'collectionsPaydownTotalAmount'
    | 'collectionsRecycleTotalAmount'
    | 'curePaydownTotalAmount'
    | 'status'
    | 'borrowingBaseReport'
  > & {
    fundingRequestEvents: Pick<
      EventWithActorGQLType,
      'created_at' | 'actionKey'
    >[];
    reportingDate: Util.FullDateStr;
  })[];
};
export const HistoryTable = ({ fundingRequests }: Props) => {
  return (
    <TableContainer whiteSpace="normal">
      <Table variant="simple">
        <Thead
          background={colors.tableHeader}
          borderBottom="1px solid lightgrey"
          padding="8px 0"
        >
          <Tr _groupHover={{ bg: 'gray.100' }}>
            <Th w="10%">Funding Request Id</Th>
            <Th textAlign="left" width="10%">
              Borrowing Base Reporting Date
            </Th>
            <Th textAlign="left" width="10%">
              Funding Request Date
            </Th>
            <Th textAlign="left" width="20%">
              Credit Facility
            </Th>
            <Th textAlign="center" width="10%">
              Draw
            </Th>
            <Th textAlign="center" width="10%">
              Recycle
            </Th>
            <Th textAlign="center" width="10%">
              Collections Paydown
            </Th>
            <Th textAlign="center" width="10%">
              Cure Paydown
            </Th>
            <Th textAlign="center" width="10%">
              Status
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {_.map(
            fundingRequests,
            ({
              id,
              created_at: createdAt,
              drawRequestTotalAmount,
              collectionsPaydownTotalAmount,
              collectionsRecycleTotalAmount,
              curePaydownTotalAmount,
              status,
              fundingRequestEvents,
              creditFacilityName,
              reportingDate,
            }) => (
              <Tr>
                <Td color={colors.info}>
                  <RouterLink to={`/funding-requests/${id}`}>{id}</RouterLink>
                </Td>
                <Td textAlign="left">
                  {commonDate.fullDateStrToHumanDateString(reportingDate)}
                </Td>
                {/* the submission date will use event data or default to created_at date when unavailable */}
                <Td textAlign="left">
                  {commonDate.dateToHumanDateString(
                    new Date(
                      _.find(
                        fundingRequestEvents,
                        (event) => event.actionKey === 'requestSubmitted',
                      )?.created_at || createdAt,
                    ),
                  )}
                </Td>
                <Td textAlign="left">{creditFacilityName}</Td>
                <Td textAlign="center">
                  {dollarNumberWithCommas(drawRequestTotalAmount)}
                </Td>
                <Td textAlign="center">
                  {dollarNumberWithCommas(collectionsRecycleTotalAmount)}
                </Td>
                <Td textAlign="center">
                  {dollarNumberWithCommas(collectionsPaydownTotalAmount)}
                </Td>
                <Td textAlign="center">
                  {dollarNumberWithCommas(curePaydownTotalAmount)}
                </Td>
                <Td textAlign="center">
                  <FundingRequestStatusBadge status={status} />
                </Td>
              </Tr>
            ),
          )}
        </Tbody>
      </Table>
    </TableContainer>
  );
};
